module.exports = __webpack_public_path__ + "img/ea97564.jpg";